import { tw } from '@/lib/utils'

// One period of a gentle audio waveform, filled to the bottom edge. Starts and
// ends at the same height/slope so two side-by-side copies tile seamlessly —
// the drift animation moves exactly one period (-50% of the two-copy track).
const WAVE_PATH =
  'M0 26 C40 18 80 12 120 16 C160 20 200 34 240 30 C280 26 320 10 360 14 ' +
  'C400 18 440 30 480 24 C520 18 560 8 600 12 C640 16 680 32 720 28 ' +
  'C760 24 800 12 840 16 C880 20 920 30 960 26 C1000 22 1040 14 1080 18 ' +
  'C1120 22 1160 28 1200 26 L1200 40 L0 40 Z'

const WaveSvg = () => (
  <svg viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden className="h-full w-1/2 shrink-0">
    <path d={WAVE_PATH} fill="currentColor" />
  </svg>
)

interface SoundwaveStripProps {
  /** Theme wave color (a `text-*` class); the fill picks it up via `currentColor`. */
  className?: string
}

/**
 * A faint, filled waveform along the card's bottom edge — two semi-transparent
 * layers drifting slowly in opposite directions, giving the card ambient "live
 * audio" motion so it reads as interactive, not decorative. Purely visual:
 * aria-hidden, pointer-events-none, under the z-10 content. Static (no drift)
 * when reduced motion is preferred.
 */
export const SoundwaveStrip = ({ className }: SoundwaveStripProps) => (
  <div
    aria-hidden
    className={tw('pointer-events-none absolute inset-x-0 bottom-0 z-0 h-10 overflow-hidden', className)}
  >
    <div className="absolute bottom-0 left-0 flex h-full w-[200%] [animation:waveDrift_26s_linear_infinite] motion-reduce:animate-none">
      <WaveSvg />
      <WaveSvg />
    </div>
    <div
      className="absolute bottom-0 left-0 flex h-[68%] w-[200%] opacity-60 [animation:waveDrift_40s_linear_infinite_reverse] motion-reduce:animate-none"
      style={{ animationDelay: '-13s' }}
    >
      <WaveSvg />
      <WaveSvg />
    </div>
  </div>
)
